import React from 'react';
import { CategoryTreeItem } from '../sub-category-map';
import { haveChildren, trackClick, SUBCATEGORY_LINK } from '../utils';
import CategoryItemShowAll from './category-item-show-all';
import { SubLevelList, SubLevelItem, SubLevelLink } from '../styles';

const CategoryItemChildren: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<ICategoryItemChildrenProps>
>> = props => {
  const topLevel = props.item;
  const { subCategoryMap, linkToItem } = props;

  return haveChildren(topLevel) ? (
    <SubLevelList>
      {subCategoryMap[topLevel.id].map(subLevel => (
        <SubLevelItem key={subLevel.id}>
          {subLevel.externalUri && (
            <SubLevelLink as="a" href={subLevel.externalUri}>
              {subLevel.name}
            </SubLevelLink>
          )}
          {!subLevel.externalUri && (
            <SubLevelLink
              to={linkToItem(subLevel)}
              onClick={() => trackClick(subLevel, SUBCATEGORY_LINK)}
            >
              {subLevel.name}
            </SubLevelLink>
          )}
        </SubLevelItem>
      ))}
      <CategoryItemShowAll item={topLevel} linkToItem={linkToItem} />
    </SubLevelList>
  ) : null;
};

interface ICategoryItemChildrenProps {
  item: CategoryTreeItem;
  subCategoryMap: Record<string, CategoryTreeItem[]>;
  linkToItem: (item: CategoryTreeItem) => string;
}

export default CategoryItemChildren;
